import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NotificationPreferencesState {
  /** When true, domain SignalR toasts are suppressed; cache invalidation still runs. */
  silenced: boolean;
  setSilenced: (silenced: boolean) => void;
  toggleSilenced: () => void;
}

export const useNotificationPreferences = create<NotificationPreferencesState>()(
  persist(
    (set) => ({
      silenced: false,
      setSilenced: (silenced) => set({ silenced }),
      toggleSilenced: () => set((state) => ({ silenced: !state.silenced })),
    }),
    {
      name: 'ledgervue-notification-preferences',
    }
  )
);
